import type { PutCentricosReportGroupConfigBody } from '@compassdigital/sdk.typescript/interface/centricos';
import type { RecordEntityId, ReportingConfig } from '@centric-os/types';
import { defineStore, type StateTree } from 'pinia';
import { useReportConfigMapper } from '../../../composables';

interface State extends StateTree {
  reportingConfig: ReportingConfig | null;
  reportingConfigDefault: ReportingConfig | null;
  isDayEdit: boolean;
  isDayPartsEdit: boolean;
  isFormDirty: boolean;
}

export function useReportingConfigStore(storeId = 'reportingConfig') {
  const store = defineStore(storeId, {
    state: (): State => ({
      reportingConfig: null,
      reportingConfigDefault: null,
      isDayEdit: false,
      isDayPartsEdit: false,
      isFormDirty: false,
    }),
    actions: {
      async getReportingConfig(location_group_id: RecordEntityId): Promise<void> {
        const { mapReportConfigResponse } = useReportConfigMapper();

        const response = await this.serviceApi.get_centricos_report_group_config(
          String(location_group_id),
        );
        this.reportingConfig = mapReportConfigResponse(response);
      },
      async getReportingConfigDefault(location_group_id: RecordEntityId): Promise<void> {
        const { mapReportConfigResponse } = useReportConfigMapper();

        const response = await this.serviceApi.get_centricos_report_config_default(
          String(location_group_id),
        );

        this.reportingConfigDefault = mapReportConfigResponse({
          ...response,
          location_group_id,
          is_default: true,
        });
      },
      async updateReportingConfig(payload: ReportingConfig) {
        const { mapReportConfigPayload, mapReportConfigResponse } = useReportConfigMapper();

        if (payload && payload.location_group_id) {
          const response = await this.serviceApi.put_centricos_report_group_config(
            String(payload.location_group_id),

            mapReportConfigPayload(payload) as PutCentricosReportGroupConfigBody,
          );
          this.reportingConfig = mapReportConfigResponse(response);
        } else {
          return Promise.reject(new Error('no category selected'));
        }
      },
      async deleteCustomConfig(location_group_id: RecordEntityId) {
        const { mapReportConfigResponse } = useReportConfigMapper();
        const response = await this.serviceApi.delete_centricos_report_group_config(
          String(location_group_id),
        );
        this.reportingConfig = mapReportConfigResponse(response);
      },
    },
    getters: {
      isReportingConfigCustom(state: State): boolean {
        return !state.reportingConfig?.is_default;
      },
    },
    pagination: false,
  });
  return store();
}
